<template>
  <v-card ripple @click="openBucket">
    <v-card-title primary-title>
      <div style='width:100%;'>
        <v-icon class="bucket_icon">storage</v-icon>
        <p class="bucket_name"><span style="font-weight:bold;">{{ name }}</span><br>
          <span style="color:grey;">{{ id }}</span>
        </p>
      </div>
      <div v-if="insights" style="width:100%; margin-top: 10px; font-size: 12px; color: grey;">
        {{ insights.containers || 0 }} containers &bull; {{ insights.datasets || 0 }} datasets &bull; {{ insights.rows || 0 }} rows<br>
        {{ formatBytes(insights.bytes) }}
      </div>
      <div v-else style="width:100%; margin-top: 10px;">
        <v-skeleton-loader type="text" width="60%" class="mx-auto mb-1"></v-skeleton-loader>
        <v-skeleton-loader type="text" width="40%" class="mx-auto"></v-skeleton-loader>
      </div>
    </v-card-title>
  </v-card>
</template>
<script>
export default {
  name: "Bucket",
  props: {
    id: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    project_id: {
      type: Number,
      required: true
    },
    insights: {
      type: Object,
      required: false,
      default: null
    }
  },
  methods: {
    formatBytes(bytes) {
      if (!bytes || isNaN(bytes) || bytes == 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      let parsed = parseFloat((bytes / Math.pow(k, i)).toFixed(2));
      if (isNaN(parsed)) return '0 Bytes';
      return parsed + ' ' + sizes[i];
    },
    openBucket(){
      this.$router.push(this.project_id + "/bucket/" + this.id);
    }
  }
}
</script>
<style scoped>
.v-card{
  cursor: pointer;
  text-align: center;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-top: 5px;
}
.bucket_icon{
  font-size: 40px;
}
.bucket_name{
  font-size: 15px;
  margin:0;
}
</style>
